/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'zongshouru': {
    width: 128,
    height: 128,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" _fill="#2c2c2c" d="M880.514 124.088c10.999 0 19.998 8.999 19.998 19.998v735.928c0 10.999-9 19.998-19.998 19.998H144.586c-10.999 0-19.998-8.999-19.998-19.998V144.086c0-10.999 8.999-19.998 19.998-19.998h735.928m0-59.994H144.586c-44.196 0-79.992 35.796-79.992 79.992v735.928c0 44.196 35.796 79.992 79.992 79.992h735.928c44.196 0 79.992-35.796 79.992-79.992V144.086c0-44.196-35.796-79.992-79.992-79.992zM64.594 244.076h119.988v59.994H64.594zm0 475.954h119.988v59.994H64.594zm623.939-443.857h-48.795L512.95 503.151 386.262 276.173h-48.795l139.186 241.576h-106.19v26.998h121.389v69.293H370.464v27.097h121.388v106.19h42.296v-106.19h121.388V614.04H534.148v-69.293h121.388v-26.998h-106.29z"/>'
  }
})
